<template>
  <div class="pa-2">
    
    <div
    v-if="hasInventoryOrReserved">

      <c-table
      :checkable="false"
      ref="table" :rows="rowsInv" :headers="headers">

        <batch-row 
        slot="row"
        slot-scope="sprps"
        :mainrow="row"
        :row="sprps.row"
        :sprps="sprps"
        :required="required"
        :debitsFrozen="debitsFrozen"
        :debits="debits">
        </batch-row>

      </c-table>

    </div>

    <div 
    v-else
    class="title font-weight-bold pa-2">
      Out of stock!
    </div>

  </div>
</template>

<script>
import BatchRow from './BatchRow'
import { mapGetters } from 'vuex'

export default {
  props: {
    sprps: null,
    row: null,
    debits: { // [{inventory_id: 666}, ...]
      type: Object,
      default: () => {
        return {}
      }
    },
    debitsFrozen: { // [{inventory_item_id, archive_id, quantity}, ...]
      type: Array,
      default: () => {
        return []
      }
    },
    required: { // {inv_item_id: quantity, inv_item_id: quantity}
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    'batch-row': BatchRow
  },
  data () {
    return {
      headers: ['Batch', 'Available', 'Used'],
      rowsInv: []
    }
  },
  computed: {
    ...mapGetters({
      getInventoryOf: 'db/inventory/getInventoryOf'
    }),
    inventory () {
      // merge all by archive_id
      var inv = JSON.parse(JSON.stringify(this.getInventoryOf(this.row.inventory_item_id)))
      var retArray = []
      for (var invItem of inv) {
        var match = retArray.find(item => item.archive_id === invItem.archive_id)
        if (match) {
          match.quantity += invItem.quantity
        } else {
          retArray.push(invItem)
        }
      }
      return retArray
    },
    reserved () {
      return this.debitsFrozen.filter(item => {
        return item.inventory_item_id === this.row.inventory_item_id
      })
    },
    combinedInventory () {
      var retArray = Object.assign([], this.inventory)
      for (var invItem of this.reserved) {
        var match = retArray.find(item => item.archive_id === invItem.archive_id)
        if (match) {
          match.quantity += invItem.quantity
        } else {
          retArray.push(invItem)
        }
      }
      return retArray
      // return this.inventory
    },
    hasInventoryOrReserved () {
      if (this.inventory.length > 0 || this.reserved.length > 0) {
        return true
      }
      return false
    }
  },
  created () {
    this.rowsInv = this.combinedInventory
  }
}
</script>
